module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('h1', {
    staticClass: "c-logo"
  }, [_c('router-link', {
    attrs: {
      "to": "/"
    }
  }, [_c('div', {
    staticClass: "c-logo__wrapper"
  }, [_c('span', {
    staticClass: "c-type-delta "
  }, [_vm._v("My")]), _vm._v(" "), _c('span', {
    staticClass: "c-type-delta c-logo__rad"
  }, [_vm._v("Rad")]), _vm._v(" "), _c('span', {
    staticClass: "c-type-delta"
  }, [_vm._v("Blog")])]), _vm._v(" "), _c('span', {
    staticClass: "c-type-echo c-logo__tagline"
  }, [_c('span', {
    staticClass: "c-logo__tagline-text"
  }, [_vm._v("- Powered by VueJS & Wordpress API -")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1281daf1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/logo/logo.vue
// module id = 138
// module chunks = 1